import { InputLabel, MenuItem, Select, Box, IconButton, Tooltip } from '@mui/material';
import React, { forwardRef, useCallback, useState } from 'react'
import _ from 'lodash';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';

const Dropdown = forwardRef((props, ref) => {
    const {
        containerSx,
        required,
        id,
        label,
        isClear,
        value = props?.multiple ? [] : '',
        onChange,
        options,
        placeholder = "",
        defaultValue = null,
        sx,
        valueKey = 'id',
        labelKey = 'label',
        disabled = false,
        disabledOptions = [],
        key,
        ...selectProps
    } = props;

    const [openSelect, setOpenSelect] = useState(false);

    const handleChange = useCallback((event) => {
        onChange(event?.target.value);
    }, [onChange]
    );

    const condMb = _.has(containerSx, 'mb') ? containerSx?.mb : 1.5;

    return (
        <Box>
            {label && <InputLabel sx={{
                textAlign: "left", color: '#000 !important', fontWeight: '600 !important', fontSize: '14px',
                fontFamily: '"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif', marginBottom: '8px'
            }} required={required}>{label}</InputLabel>}
            <Select
                ref={ref}
                id="demo-simple-select-autowidth"
                labelId="demo-simple-select-autowidth-label"
                defaultValue={defaultValue}
                required={required}
                value={value}
                onChange={handleChange}
                displayEmpty
                disabled={disabled}
                open={openSelect}
                onOpen={() => setOpenSelect(true)}
                onClose={() => setOpenSelect(false)}
                renderValue={(selected) => {
                    if (value === "") {
                        return (
                            <div style={{ color: "#a2a2a2", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-flex", width: "100%" }}>
                                {placeholder}
                            </div>
                        )
                    } else {
                        return options?.find((opt) => String(opt[valueKey]) === String(selected))?.[labelKey] || placeholder;
                    }
                }}
                MenuProps={{
                    style: {
                        maxHeight: 400,
                    },
                }}
                sx={[{
                    backgroundColor: '#FFF',
                    width: '100%',
                    height: '35px',
                    fontSize: "14px",
                    borderRadius: '10px'
                }, { ...sx }]}
                {...selectProps}
                IconComponent={KeyboardArrowDownIcon}
            >
                <Box sx={{ display: "flex", justifyContent: 'space-between' }}>
                    {placeholder && (
                        <MenuItem value={value != null ? "" : null} sx={{
                            color: '#a2a2a2 !important', fontSize: "14px"
                        }} disabled>
                            {placeholder}
                        </MenuItem>
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '5px' }}>
                        <Tooltip
                            title={"Close"}
                            arrow
                        >
                            <IconButton size="small" onClick={() => {
                                setOpenSelect(false);
                            }}>
                                <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                {options?.map((v, k) => (
                    <MenuItem value={v[valueKey]} disabled={disabledOptions.includes(v[valueKey])} key={v[valueKey]}
                        onClick={(e) => {
                            if (String(v[valueKey]) === String(value)) {
                                onChange('');
                            } else {
                                onChange(v[valueKey]);
                            }
                        }}
                        sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px", justifyContent: 'space-between', margin: '1px 5px', borderRadius: '7px' }}
                        title={v[labelKey]}
                    >
                        {v[labelKey]}
                        {(v[valueKey] === +value || v[labelKey] === value) && (
                            <DoneIcon className='doneIcon' />
                        )}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    )
})

export default Dropdown;